module.exports = __webpack_public_path__ + "static/media/CC20-AP100-12.0a5d1cb8.png";